import { modifyConsumptionService } from '@modules/modify-consumption/infrastructure/modify-consumption.service'
import {
  modifyConsumptionParams,
  ApiErrors,
  API_ERRORS_MESSAGE,
} from '@modules/modify-consumption/domain/modify-consumption.types'

type Callbacks = {
  onConsumptionModified: () => void
  onNetworkError: (errorMessage: string) => void
}

export function modifyConsumption() {
  return { execute }

  async function execute(
    {
      cups,
      previousAnnualConsumption,
      newConsumptions,
      reason,
    }: modifyConsumptionParams,
    { onConsumptionModified, onNetworkError }: Callbacks
  ) {
    try {
      await modifyConsumptionService.modifyConsumption({
        cups,
        previousAnnualConsumption,
        newConsumptions,
        reason,
      })
      onConsumptionModified()
    } catch (error) {
      const status = error.response?.status
      if (status) {
        onNetworkError(API_ERRORS_MESSAGE[status as keyof ApiErrors])
      }
    }
  }
}
